import React, { useState, useEffect } from "react";
import "./HighScores.css";
import { useFirebase } from "../contexts/FirebaseContext";
import { useLanguage } from "../contexts/LanguageContext";

const HighScores = ({
  currentScore,
  onClose = () => {},
  inline = false,
  showCurrentScore = true,
}) => {
  const { getHighScores, displayName, userId } = useFirebase();
  const { t } = useLanguage();
  const [highScores, setHighScores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userRank, setUserRank] = useState(null);

  useEffect(() => {
    const loadHighScores = async () => {
      setLoading(true);
      try {
        // Load top scores (limit to 10)
        const scores = await getHighScores(10);
        setHighScores(scores.slice(0, 10)); // Ensure max 10 items

        // Find user's rank
        if (currentScore) {
          const rank = scores.findIndex((s) => s.score <= currentScore) + 1;
          if (rank > 0) {
            setUserRank(rank);
          } else if (scores.length < 10) {
            setUserRank(scores.length + 1);
          }
        }
      } catch (error) {
        console.error("Error loading high scores:", error);
      } finally {
        setLoading(false);
      }
    };

    loadHighScores();
  }, [currentScore, getHighScores, displayName, userId]);

  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleDateString();
  };

  const containerClass = inline ? "high-scores-inline" : "high-scores-container";
  const cardClass = inline
    ? "high-scores-card high-scores-inline-card"
    : "high-scores-card";

  return (
    <div className={containerClass}>
      <div className={cardClass}>
        <h2 className="high-scores-title">🏆 {t("highScores")}</h2>
        
        {currentScore && showCurrentScore && (
          <div className="current-score-display">
            <p className="current-score-label">{t("yourScore")}</p>
            <p className="current-score-value">{currentScore}</p>
            {userRank && userRank <= 10 && (
              <p className="current-score-rank">
                {t("yourRank")} #{userRank}
              </p>
            )}
          </div>
        )}

        {loading ? (
          <div className="high-scores-loading">{t("loading")}</div>
        ) : highScores.length === 0 ? (
          <div className="high-scores-empty">{t("noHighScores")}</div>
        ) : (
          <div className="high-scores-list">
            {highScores.map((score, index) => (
              <div
                key={score.id}
                className={`high-score-item ${
                  score.userId && userId && score.userId === userId
                    ? "current-user-score"
                    : ""
                }`}
              >
                <div className="high-score-rank">#{index + 1}</div>
                <div className="high-score-name">{score.displayName || t("anonymous")}</div>
                <div className="high-score-value">{score.score}</div>
                <div className="high-score-date">{formatDate(score.timestamp)}</div>
              </div>
            ))}
          </div>
        )}

        {!inline && (
          <button className="high-scores-close-button" onClick={onClose}>
            {t("close")}
          </button>
        )}
      </div>
    </div>
  );
};

export default HighScores;

